const APPLE_PRIVATE_RELAY_DOMAIN = '@privaterelay.appleid.com';

export function isPrivateRelayEmail(email: string): boolean {
  return email.toLowerCase().endsWith(APPLE_PRIVATE_RELAY_DOMAIN);
}
